import classNames from "classnames";
import { Button } from "PFComponents/button";

import scrollToLeft from "../../utils/scroll_to_left";
import css from "./arrows.module.scss";

type ArrowProps = {
  el: Element | null | undefined;
  step: number;
  className: string;
  scroll: number;
};

const Arrow = ({ el, step, className, scroll }: ArrowProps) => {
  const isDisabled = !el
    ? true
    : step > 0
      ? scroll + el.clientWidth >= el.scrollWidth // fully scrolled
      : scroll === 0; // starting position

  return (
    <Button
      icon={step > 0 ? "caret-right" : "caret-left"}
      kind="blank"
      className={classNames(css.arr, className, { [css.off]: isDisabled })}
      onClick={() => scrollToLeft(el as HTMLElement | null | undefined, (el?.scrollLeft ?? 0) + step)}
    />
  );
};

type ArrowsProps = {
  scrollEl: Element | null | undefined;
  scrollLeft: number;
};

export const Arrows = ({ scrollEl, scrollLeft }: ArrowsProps) => {
  const step = scrollEl ? (scrollEl as HTMLElement).offsetWidth / 2 : 0; // half the page
  const bottom = scrollEl ? (scrollEl as HTMLElement).offsetHeight - scrollEl.clientHeight : 0;

  return (
    <div className={css.root} style={{ bottom }}>
      <div className={css.leftFade} />
      <div className={css.rightFade} />
      <Arrow el={scrollEl} className={css.prev} scroll={scrollLeft} step={-step} />
      <Arrow el={scrollEl} className={css.next} scroll={scrollLeft} step={step} />
    </div>
  );
};
